"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var slider_1 = __importDefault(require("./slider"));
var carousel = function () {
    var carouselWrappers = document.querySelectorAll('.c-carouselSec_swiper');
    if (!carouselWrappers) {
        return;
    }
    carouselWrappers.forEach(function (wrapper) {
        (0, slider_1.default)({
            container: wrapper,
            options: {
                slidesPerView: 1,
                spaceBetween: 24,
                autoplay: {
                    delay: 3000,
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                },
            },
        });
    });
};
carousel();
